import { apiFetch } from './utils/api';

export const securityPerformance = {
  get: async () => {
    const options = {
      method: 'GET',
    };

    const url = '/v2/qlik/security-performance';

    const { body } = await apiFetch(url, {
      ...options,
    });

    return body;
  },
};
